import { render } from "./Occupier.vue?vue&type=template&id=b46da2e8&scoped=true"
import script from "./Occupier.vue?vue&type=script&lang=js"
export * from "./Occupier.vue?vue&type=script&lang=js"

import "./Occupier.vue?vue&type=style&index=0&id=b46da2e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b46da2e8"]])

export default __exports__